import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderComponent } from './components/header/header.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ModuleSwitcherComponent } from './components/module-switcher/module-switcher.component';
import { ErrorComponent } from './components/error/error.component';
import { DataService } from './services/data.service';
import { CommonService } from '../common/common.service';
import { DashboardBarChartComponent } from './components/dashboard-bar-chart/dashboard-bar-chart.component';
import { DashboardPieChartComponent } from './components/dashboard-pie-chart/dashboard-pie-chart.component';
import { AnalyticsPieChartComponent } from './components/analytics-pie-chart/analytics-pie-chart.component';
import { ActivateLoginService } from './services/activate-login.service';
import { AuthService } from './services/auth.service';
import { ApplicationLevelBarChartComponent } from './components/application-level-bar-chart/application-level-bar-chart.component';
import { CoustomSelectComponent } from './components/coustom-select/coustom-select.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    HeaderComponent,
    SnackbarComponent,
    SpinnerComponent,
    ModuleSwitcherComponent,
    ErrorComponent,
    DashboardBarChartComponent,
    DashboardPieChartComponent,
    AnalyticsPieChartComponent,
    ApplicationLevelBarChartComponent,
    CoustomSelectComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'), 
    }),
  ],
  exports: [
    HeaderComponent,
    SpinnerComponent,
    SnackbarComponent,
    DashboardBarChartComponent,
    DashboardPieChartComponent,
    AnalyticsPieChartComponent,
    ApplicationLevelBarChartComponent,
    CoustomSelectComponent
  ],
  providers: [
    ActivateLoginService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthService,
      multi: true
    },
    CommonService,
    DataService
  ]
})
export class SharedModule { }
